// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlipayRoundSquareFilledSvg from "@fishx/icons-svg/es/asn/AlipayRoundSquareFilled";
import FishxIcon from '../components/FishxIcon';

var AlipayRoundSquareFilled = function AlipayRoundSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlipayRoundSquareFilledSvg
  }));
};

AlipayRoundSquareFilled.displayName = 'AlipayRoundSquareFilled';
export default React.forwardRef(AlipayRoundSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlipayRoundSquareFilled.js
// module id = 1965
// module chunks = 0